import React from 'react';
import {useGlobalContext} from '../../core/GlobalContext';
import ButtonAction from '../ButtonAction';
import ModalPopup from '../ModalPopup';
import icon from '../../../assets/icons/cancel-circle.svg';
import styles from './PopupWindowContainer.module.scss';

const PopupWindowContainer = () => {
  const {popupPanelContent, closePopupPanel, layoutDirection} = useGlobalContext();

  return (
    <ModalPopup isOpen={true} customModalStyles={styles.popupModal}>
      <div dir={layoutDirection} className={styles.popupInnerWrapper}>
        <ButtonAction
          variant={'icon'}
          icon={icon}
          onClick={closePopupPanel}
          customClassnames={{container: styles.closeBtn}}
        />
        {popupPanelContent}
      </div>
    </ModalPopup>
  );
};
export default PopupWindowContainer;
